import { useCallback, useMemo, useState } from 'react'

/**
 * @param steps (array) each step should contain a label (node) and a key (string)
 * @param initialStepKey step where state will be initialized with
 */
const useModalSteps = ({ steps, initialStepKey }) => {
  const findStepIndex = useCallback((stepKey) => steps.findIndex((step) => step.key === stepKey), [steps])

  const initialStepIndex = useMemo(() => findStepIndex(initialStepKey), [initialStepKey, findStepIndex])

  const [currentStepIndex, setCurrentStepIndex] = useState(initialStepIndex < 0 ? 0 : initialStepIndex)
  const currentStepKey = steps[currentStepIndex]?.key

  const nextStep = useCallback(() => {
    const nextIndex = currentStepIndex + 1
    if (nextIndex < steps.length) {
      setCurrentStepIndex(nextIndex)
    } else {
      console.error('nextStep: next step exceeds the steps array length')
    }
  }, [currentStepIndex, steps.length])

  const previousStep = useCallback(() => {
    const prevIndex = currentStepIndex - 1
    if (prevIndex >= 0) {
      setCurrentStepIndex(prevIndex)
    } else {
      console.error('previousStep: previous step cannot be lower than 0')
    }
  }, [currentStepIndex])

  const goToStep = useCallback(
    (stepKey) => {
      const newIndex = findStepIndex(stepKey)
      if (newIndex !== undefined) {
        setCurrentStepIndex(newIndex)
      } else {
        console.error(`goToStep: invalid step key ${stepKey}`)
      }
    },
    [findStepIndex],
  )

  return {
    currentStepIndex,
    currentStepKey,
    nextStep,
    previousStep,
    goToStep,
  }
}

export default useModalSteps
